import script from "./CronometroCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CronometroCard.vue?vue&type=script&setup=true&lang=js"

import "./CronometroCard.vue?vue&type=style&index=0&id=5280560d&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5280560d"]])

export default __exports__